import { render, staticRenderFns } from "./ProductEditTranslation.vue?vue&type=template&id=5d654a23&"
import script from "./ProductEditTranslation.vue?vue&type=script&lang=js&"
export * from "./ProductEditTranslation.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports